import { render, staticRenderFns } from "./projectFiles.vue?vue&type=template&id=3006ca98&"
import script from "./projectFiles.vue?vue&type=script&lang=js&"
export * from "./projectFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports